import { createContext } from "react";
import type { MultiSelectContextType } from "./MultiSelectContext.types";

const MultiSelectContext = createContext<MultiSelectContextType | undefined>(undefined);
MultiSelectContext.displayName = "MultiSelectContext";

export default MultiSelectContext;
